import { ProseTheme } from '@/components/Prose/theme';
import { tw } from '@/utils/tw';

const RichTextBox = tw.theme({
  extend: ProseTheme,
  base: ['group-[.bg]/box:p-grid-gap'],
});

export default RichTextBox;
